import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("VIN Info controller connected");
    this.debugModalState();
    // document.getElementById("loading-gif")?.remove();
    this.element.querySelectorAll(".header-filter").forEach((item) => {
      item.addEventListener("click", (e) => this.filterResults(e));
    });

    this.element.querySelectorAll(".scroller").forEach((item) => {
      item.addEventListener("click", (e) => this.scroll(e));
    });
  }

  debugModalState() {
    const modalElement = document.getElementById('converter-pricing-modal');
    if (!modalElement) {
      console.log("Modal element not found in DOM");
      return;
    }

    console.log("Modal element found:", {
      visible: $(modalElement).is(':visible'),
      display: $(modalElement).css('display'),
      opacity: $(modalElement).css('opacity'),
      zIndex: $(modalElement).css('z-index'),
      classList: Array.from(modalElement.classList),
      attributes: this.getElementAttributes(modalElement)
    });

    // Debug modal backdrop
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      console.log("Modal backdrop found:", {
        visible: $(backdrop).is(':visible'),
        display: $(backdrop).css('display'),
        opacity: $(backdrop).css('opacity'),
        zIndex: $(backdrop).css('z-index'),
        classList: Array.from(backdrop.classList)
      });
    } else {
      console.log("No modal backdrop found");
    }
  }

  getElementAttributes(element) {
    const attributes = {};
    for (const attr of element.attributes) {
      attributes[attr.name] = attr.value;
    }
    return attributes;
  }

  filterResults(e) {
    e.preventDefault();
    const targetClass = e.currentTarget.dataset.target;
    if (targetClass == "all") {
      $(".header-result").removeClass("d-none");
    } else if (targetClass == "options") {
      $(".header-result").removeClass("d-none");
      $(
        ".header-mechanical, .header-exterior, .header-interior, .header-safety"
      ).addClass("d-none");
    } else {
      $(".header-result").addClass("d-none");
      $(`.header-${targetClass}`).removeClass("d-none");
    }
    this.reapplyAlternatingRows();
  }

  scroll(e) {
    const element = document.getElementById(e.target.dataset.targetId);
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }

  // Reapply alternating row backgrounds to visible rows only
  reapplyAlternatingRows() {
    // Find all visible header-result rows (not hidden by d-none class)
    const visibleRows = $("li.header-result:not(.d-none):visible");
    
    // Remove existing alternating classes
    visibleRows.removeClass('row-even');
    
    // Apply alternating classes based on visible position
    visibleRows.each((index, element) => {
      if (index % 2 === 0) {
        $(element).addClass('row-even');
      }
    });
  }
}
